export default __webpack_public_path__ + "static/img-4-b1aae0c4237958e0eb7e4ca6fb564f20.png";